/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeDeleteController',BoardMembershipFeeDeleteController);

    BoardMembershipFeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'MembershipFee'];

    function BoardMembershipFeeDeleteController($uibModalInstance, entity, MembershipFee) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MembershipFee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
